(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');

    function connect(hero) {
      if (hero.dataset.campaignHeroReady) return;
      hero.dataset.campaignHeroReady = 'true';
      if (hero.dataset.motion !== 'true') return;

      const media = hero.querySelector('[data-hero-media]');
      const text = hero.querySelector('[data-hero-text]');
      const cue = hero.querySelector('[data-hero-cue]');
      let frame = null;

      function tick() {
        frame = null;
        if (reduced.matches) return;

        const rect = hero.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, -rect.top / Math.max(1, rect.height)));

        if (media) media.style.transform = `translate3d(0, ${(progress * 50).toFixed(1)}px, 0)`;
        if (text) {
          text.style.transform = `translate3d(0, ${(progress * -21).toFixed(1)}px, 0)`;
          text.style.opacity = String(Math.max(0, 1 - progress * 1.5));
        }
        if (cue) cue.style.opacity = String(Math.max(0, 1 - progress * 4));
      }

      window.addEventListener(
        'scroll',
        () => {
          if (!frame) frame = requestAnimationFrame(tick);
        },
        { passive: true }
      );
      tick();
    }

    function init(root) {
      (root || document).querySelectorAll('[data-campaign-hero]').forEach(connect);
    }

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-image"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');

    function connect(section) {
      if (section.dataset.campaignZoomReady) return;
      section.dataset.campaignZoomReady = 'true';
      if (section.dataset.motion !== 'true') return;

      const media = section.querySelector('[data-zoom-media]');
      if (!media) return;

      let frame = null;

      /* The photo starts slightly enlarged and settles to its natural size as
         it scrolls into view — the design's slow zoom-out. */
      function tick() {
        frame = null;
        if (reduced.matches) return;

        const rect = section.getBoundingClientRect();
        const viewport = window.innerHeight;
        const progress = Math.min(
          1,
          Math.max(0, (viewport - rect.top) / Math.max(1, viewport + rect.height * 0.5))
        );
        media.style.transform = `scale(${(1 + (1 - progress) * 0.09).toFixed(4)})`;
      }

      window.addEventListener(
        'scroll',
        () => {
          if (!frame) frame = requestAnimationFrame(tick);
        },
        { passive: true }
      );
      tick();
    }

    function init(root) {
      (root || document).querySelectorAll('[data-campaign-zoom]').forEach(connect);
    }

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function connect(story) {
      if (story.dataset.campaignStoryReady) return;
      story.dataset.campaignStoryReady = 'true';

      const images = Array.prototype.slice.call(story.querySelectorAll('[data-story-img]'));
      const beats = Array.prototype.slice.call(story.querySelectorAll('[data-story-beat]'));
      if (images.length < 2 || beats.length === 0) return;

      /* A beat counts as active while it crosses the middle band of the
         viewport, so the photo always belongs to the text being read. */
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = entry.target.dataset.storyBeat;
            images.forEach((image) => {
              image.toggleAttribute('data-active', image.dataset.storyImg === index);
            });
          });
        },
        { rootMargin: '-48% 0px -48% 0px', threshold: 0 }
      );

      beats.forEach((beat) => observer.observe(beat));
    }

    function init(root) {
      (root || document).querySelectorAll('[data-campaign-story]').forEach(connect);
    }

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const MENU_KEY = 'elmewind:collection-filter-menu';

    function readMenuKey() {
      try {
        return sessionStorage.getItem(MENU_KEY);
      } catch (error) {
        return null;
      }
    }

    function writeMenuKey(value) {
      try {
        if (value) {
          sessionStorage.setItem(MENU_KEY, value);
        } else {
          sessionStorage.removeItem(MENU_KEY);
        }
      } catch (error) {
        /* Storage is blocked in some private modes; the dropdown just won't reopen. */
      }
    }

    document.addEventListener('change', (event) => {
      const form = event.target.closest('[data-collection-form]');
      if (!form) return;
      if (!event.target.matches('select, input[type="checkbox"]')) return;

      /*
        Filtering is a full page load, so remember which dropdown was in use and
        reopen it afterwards — otherwise picking a second value in the same
        dropdown means reopening it by hand every time.
      */
      const menu = event.target.closest('[data-filter-menu]');
      writeMenuKey(menu ? menu.dataset.filterMenu : null);

      form.submit();
    });

    /* One dropdown at a time. `toggle` doesn't bubble, so listen in the capture phase. */
    document.addEventListener(
      'toggle',
      (event) => {
        const menu = event.target;
        if (!menu.matches('[data-filter-menu]')) return;
        if (!menu.open) return;

        document.querySelectorAll('[data-filter-menu][open]').forEach((other) => {
          if (other !== menu) other.open = false;
        });
      },
      true
    );

    document.addEventListener('click', (event) => {
      document.querySelectorAll('[data-filter-menu][open]').forEach((menu) => {
        if (!menu.contains(event.target)) menu.open = false;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const menu = document.querySelector('[data-filter-menu][open]');
      if (!menu) return;

      menu.open = false;
      menu.querySelector('summary').focus();
    });

    /*
      Liquid can't read query parameters, and Shopify hides a boolean filter's
      true_value when nothing in the unfiltered view matches it (a fully
      sold-out catalogue). Re-sync the checkbox from the URL so it always
      reflects the filter that is actually applied.
    */
    function syncStockBox() {
      const box = document.querySelector('[data-stock-toggle]');
      if (!box || !box.name) return;

      const params = new URLSearchParams(window.location.search);
      box.checked = params.getAll(box.name).includes(box.value);
    }

    function reopenMenu() {
      const key = readMenuKey();
      writeMenuKey(null);
      if (!key) return;

      document.querySelectorAll('[data-filter-menu]').forEach((menu) => {
        if (menu.dataset.filterMenu !== key) return;

        menu.open = true;
        const bar = menu.closest('[data-collection-bar]');
        if (bar) bar.scrollIntoView({ block: 'nearest' });
      });
    }

    function init() {
      syncStockBox();
      reopenMenu();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    /* The header renders one search panel per state. Both are toggled together
       so the panel stays open across the swap, and focus goes to whichever
       state is on screen. */

    function state() {
      const pinned = document.documentElement.hasAttribute('data-header-pinned');
      return document.querySelector(pinned ? '[data-header-compact]' : '[data-header-full]');
    }

    function isOpen() {
      const el = document.querySelector('[data-search-panel]');
      return el ? !el.hasAttribute('hidden') : false;
    }

    function setOpen(open) {
      document.querySelectorAll('[data-search-panel]').forEach((el) => {
        el.toggleAttribute('hidden', !open);
      });
      document.querySelectorAll('[data-search-toggle]').forEach((btn) => {
        btn.setAttribute('aria-expanded', String(open));
      });

      if (!open) return;

      const current = state();
      const input = current ? current.querySelector('[data-search-input]') : null;
      if (input) input.focus();
    }

    /* Mobile menu drawer
       ----------------------------------------------------------------
       A modal <dialog>, so the platform handles the focus trap, Escape, and
       handing focus back to the button that opened it. */

    function menu() {
      return document.querySelector('[data-menu-drawer]');
    }

    function syncMenuButtons(open) {
      document.querySelectorAll('[data-menu-open]').forEach((btn) => {
        btn.setAttribute('aria-expanded', String(open));
      });
    }

    function setMenuOpen(open) {
      const el = menu();
      if (!el) return;

      if (open) {
        if (typeof el.showModal !== 'function' || el.open) return;
        el.showModal();
        syncMenuButtons(true);
        return;
      }

      if (el.open) el.close();
    }

    /* `close` doesn't bubble, so catch it on the way down. Escape and the
       backdrop both get here without going through the click handler. */
    document.addEventListener(
      'close',
      (event) => {
        const el = event.target;
        if (el && el.hasAttribute && el.hasAttribute('data-menu-drawer')) syncMenuButtons(false);
      },
      true
    );

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-menu-open]')) {
        event.preventDefault();
        /* The drawer takes over the screen, so nothing else stays open behind
           it. */
        setOpen(false);
        if (window.ElmeWind && window.ElmeWind.closeDrawer) window.ElmeWind.closeDrawer();
        setMenuOpen(true);
        return;
      }

      if (event.target.closest('[data-menu-close]')) {
        event.preventDefault();
        setMenuOpen(false);
        return;
      }

      if (event.target.closest('[data-menu-search]')) {
        event.preventDefault();
        /* Closing first hands focus back to the menu button; opening search
           then moves it on to the input. */
        setMenuOpen(false);
        setOpen(true);
        return;
      }

      if (event.target.closest('[data-search-toggle]')) {
        event.preventDefault();
        setOpen(!isOpen());
        return;
      }

      if (event.target.closest('[data-search-close]')) {
        event.preventDefault();
        setOpen(false);
        return;
      }

      /* A click on the drawer's backdrop lands on the dialog itself. */
      const drawer = menu();
      if (drawer && drawer.open && event.target === drawer) setMenuOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (!isOpen()) return;

      setOpen(false);

      const current = state();
      const toggle = current ? current.querySelector('[data-search-toggle]') : null;
      if (toggle) toggle.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    /* ----------------------------------------------------------------
       Gallery: stage, thumbs, arrows, swipe, lightbox
       ---------------------------------------------------------------- */

    function setSlide(index) {
      const gallery = document.querySelector('[data-gallery]');
      if (!gallery) return;

      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      if (!slides.length) return;

      const total = slides.length;
      const next = ((index % total) + total) % total;

      slides.forEach((slide) => {
        slide.toggleAttribute('data-active', Number(slide.dataset.gallerySlide) === next);
        if (Number(slide.dataset.gallerySlide) !== next) {
          const video = slide.querySelector('video');
          if (video && !video.paused) video.pause();
        }
      });

      gallery.querySelectorAll('[data-gallery-select]').forEach((thumb) => {
        const on = Number(thumb.dataset.gallerySelect) === next;
        thumb.toggleAttribute('data-active', on);
        if (on) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });

      const counter = gallery.querySelector('[data-gallery-counter]');
      if (counter) counter.textContent = `${next + 1} / ${total}`;

      gallery.dataset.index = String(next);
      syncLightbox(next);
    }

    function currentIndex() {
      const gallery = document.querySelector('[data-gallery]');
      return gallery ? Number(gallery.dataset.index || 0) : 0;
    }

    function step(delta) {
      setSlide(currentIndex() + delta);
    }

    /* ----------------------------------------------------------------
       Lightbox
       ---------------------------------------------------------------- */

    function lightbox() {
      return document.querySelector('[data-lightbox]');
    }

    function syncLightbox(index) {
      const box = lightbox();
      if (!box) return;

      const slides = [...box.querySelectorAll('[data-lightbox-slide]')];
      if (!slides.length) return;

      const total = slides.length;
      const clamped = ((index % total) + total) % total;

      slides.forEach((slide) => {
        slide.toggleAttribute('data-active', Number(slide.dataset.lightboxSlide) === clamped);
      });

      box.querySelectorAll('[data-lightbox-select]').forEach((thumb) => {
        thumb.toggleAttribute('data-active', Number(thumb.dataset.lightboxSelect) === clamped);
      });

      const counter = box.querySelector('[data-lightbox-counter]');
      if (counter) counter.textContent = `${clamped + 1} / ${total}`;

      box.dataset.index = String(clamped);
    }

    /* `origin` is the clicked point as a fraction of the image, so zooming in
       lands on what was clicked instead of the top-left corner. */
    function setZoom(on, origin) {
      const box = lightbox();
      if (!box) return;

      const was = box.hasAttribute('data-zoomed');
      box.toggleAttribute('data-zoomed', on);

      const hint = box.querySelector('[data-lightbox-hint]');
      if (hint) {
        hint.textContent = on ? hint.dataset.hintOut || hint.textContent : hint.dataset.hintIn || hint.textContent;
      }

      if (!on || was) return;

      const stage = box.querySelector('[data-lightbox-stage]');
      if (!stage) return;
      stage.scrollLeft = (stage.scrollWidth - stage.clientWidth) * (origin ? origin.x : 0.5);
      stage.scrollTop = (stage.scrollHeight - stage.clientHeight) * (origin ? origin.y : 0.5);
    }

    /* Drag to pan while zoomed. Without this a mouse drag lands as a click on
       the image and toggles the zoom straight back off. */

    let pan = null;
    let dragged = false;

    document.addEventListener('pointerdown', (event) => {
      dragged = false;

      const box = lightbox();
      if (!box || !box.open || !box.hasAttribute('data-zoomed')) return;
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      const stage = event.target.closest('[data-lightbox-stage]');
      if (!stage) return;

      pan = {
        stage: stage,
        x: event.clientX,
        y: event.clientY,
        left: stage.scrollLeft,
        top: stage.scrollTop,
      };
      stage.setPointerCapture(event.pointerId);
    });

    document.addEventListener('pointermove', (event) => {
      if (!pan) return;
      const dx = event.clientX - pan.x;
      const dy = event.clientY - pan.y;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) dragged = true;
      pan.stage.scrollLeft = pan.left - dx;
      pan.stage.scrollTop = pan.top - dy;
    });

    function endPan(event) {
      if (!pan) return;
      if (pan.stage.hasPointerCapture(event.pointerId)) pan.stage.releasePointerCapture(event.pointerId);
      pan = null;
    }

    document.addEventListener('pointerup', endPan);
    document.addEventListener('pointercancel', endPan);

    /* Otherwise the browser's native image drag takes over the pan. */
    document.addEventListener('dragstart', (event) => {
      if (pan && event.target.closest('.lightbox__image')) event.preventDefault();
    });

    document.addEventListener('click', (event) => {
      const open = event.target.closest('[data-gallery-open]');
      if (open) {
        event.preventDefault();
        const box = lightbox();
        if (box && typeof box.showModal === 'function') {
          syncLightbox(Number(open.dataset.galleryOpen));
          setZoom(false);
          box.showModal();
        }
        return;
      }

      const select = event.target.closest('[data-gallery-select]');
      if (select) {
        event.preventDefault();
        setSlide(Number(select.dataset.gallerySelect));
        return;
      }

      if (event.target.closest('[data-gallery-prev]')) {
        event.preventDefault();
        step(-1);
        return;
      }

      if (event.target.closest('[data-gallery-next]')) {
        event.preventDefault();
        step(1);
        return;
      }

      if (event.target.closest('[data-lightbox-close]')) {
        event.preventDefault();
        const box = lightbox();
        if (box) box.close();
        return;
      }

      const lbSelect = event.target.closest('[data-lightbox-select]');
      if (lbSelect) {
        event.preventDefault();
        setZoom(false);
        syncLightbox(Number(lbSelect.dataset.lightboxSelect));
        return;
      }

      const lbPrev = event.target.closest('[data-lightbox-prev]');
      const lbNext = event.target.closest('[data-lightbox-next]');
      if (lbPrev || lbNext) {
        event.preventDefault();
        const box = lightbox();
        if (box) {
          setZoom(false);
          syncLightbox(Number(box.dataset.index || 0) + (lbNext ? 1 : -1));
        }
        return;
      }

      const image = event.target.closest('.lightbox__image');
      if (image) {
        /* A pan gesture ends in a click — don't read that as zoom out. */
        if (dragged) {
          dragged = false;
          return;
        }

        const box = lightbox();
        const rect = image.getBoundingClientRect();
        setZoom(box ? !box.hasAttribute('data-zoomed') : false, {
          x: (event.clientX - rect.left) / rect.width,
          y: (event.clientY - rect.top) / rect.height,
        });
      }
    });

    document.addEventListener('keydown', (event) => {
      const box = lightbox();
      if (!box || !box.open) return;

      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        setZoom(false);
        syncLightbox(Number(box.dataset.index || 0) + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });

    /* Touch swipe on the stage and in the lightbox */

    let touchX = null;

    function onTouchStart(event) {
      /* While zoomed, a horizontal drag pans the image — leave it to the
         stage's own scrolling instead of stepping to the next slide. */
      const box = lightbox();
      if (box && box.open && box.hasAttribute('data-zoomed')) return;
      touchX = event.touches[0].clientX;
    }

    function onTouchEnd(event) {
      if (touchX === null) return;
      const dx = event.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) < 45) return;

      const box = lightbox();
      if (box && box.open) {
        const total = box.querySelectorAll('[data-lightbox-slide]').length;
        const at = Number(box.dataset.index || 0);
        setZoom(false);
        syncLightbox(dx < 0 ? at + 1 : at - 1 + total);
      } else {
        step(dx < 0 ? 1 : -1);
      }
    }

    document.addEventListener('touchstart', (event) => {
      if (event.target.closest('[data-gallery-stage], [data-lightbox-stage]')) onTouchStart(event);
    }, { passive: true });

    document.addEventListener('touchend', (event) => {
      if (event.target.closest('[data-gallery-stage], [data-lightbox-stage]')) onTouchEnd(event);
    });

    /* ----------------------------------------------------------------
       Variant selection
       ---------------------------------------------------------------- */

    function variantData() {
      const el = document.querySelector('[data-variant-data]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (error) {
        return null;
      }
    }

    function onVariantChange() {
      const picker = document.querySelector('[data-variant-picker]');
      const variants = variantData();
      if (!picker || !variants) return;

      const chosen = [...picker.querySelectorAll('input[type="radio"]:checked')].map((input) => input.value);
      const match = variants.find(
        (candidate) =>
          candidate.options.length === chosen.length &&
          candidate.options.every((value, index) => value === chosen[index])
      );

      const idInput = document.querySelector('[data-variant-id]');
      const button = document.querySelector('[data-add-button]');
      const label = document.querySelector('[data-add-label]');

      if (!match) {
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
        }
        if (label) label.textContent = label.dataset.labelUnavailable || label.textContent;
        return;
      }

      if (idInput) idInput.value = match.id;

      document.querySelectorAll('[data-product-price]').forEach((el) => {
        el.textContent = match.price;
      });

      const compare = document.querySelector('[data-product-compare]');
      if (compare) {
        compare.textContent = match.has_compare ? match.compare_at_price : '';
        compare.hidden = !match.has_compare;
      }

      if (button) {
        button.disabled = !match.available;
        if (match.available) {
          button.removeAttribute('aria-disabled');
        } else {
          button.setAttribute('aria-disabled', 'true');
        }
      }

      if (label) {
        label.textContent = match.available
          ? label.dataset.labelDefault || label.textContent
          : label.dataset.labelSoldOut || label.textContent;
      }

      if (match.id && window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }

      if (match.media_id) {
        const thumb = document.querySelector(`[data-gallery-select][data-media-id="${match.media_id}"]`);
        if (thumb) setSlide(Number(thumb.dataset.gallerySelect));
      }
    }

    document.addEventListener('change', (event) => {
      if (event.target.closest('[data-variant-picker]')) onVariantChange();
    });

    /* ----------------------------------------------------------------
       Engraving
       ---------------------------------------------------------------- */

    /*
      Trimming on the way out of the field means a name typed with stray
      spaces reaches the order clean, and that spaces alone still count as
      an empty required field.
    */
    document.addEventListener('change', (event) => {
      const field = event.target.closest('[data-engraving]');
      if (field) field.value = field.value.trim();
    });

    /* Initialise */

    if (document.querySelector('[data-gallery]')) setSlide(0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-series-scroller]').forEach((scroller) => {
      let drag = null;
      let draggedAt = 0;

      scroller.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        drag = { x: event.clientX, left: scroller.scrollLeft, moved: false };
      });

      scroller.addEventListener('pointermove', (event) => {
        if (!drag) return;
        const dx = event.clientX - drag.x;
        if (Math.abs(dx) > 5) {
          drag.moved = true;
          scroller.setAttribute('data-dragging', '');
        }
        scroller.scrollLeft = drag.left - dx;
      });

      function end() {
        if (drag && drag.moved) draggedAt = Date.now();
        drag = null;
        scroller.removeAttribute('data-dragging');
      }

      scroller.addEventListener('pointerup', end);
      scroller.addEventListener('pointerleave', end);
      scroller.addEventListener('pointercancel', end);

      scroller.addEventListener('click', (event) => {
        if (Date.now() - draggedAt < 220) {
          event.preventDefault();
          event.stopPropagation();
        }
      });

      scroller.addEventListener('dragstart', (event) => event.preventDefault());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
